// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2tR0N","label":"Section_label__314vX","contentWrap":"Section_contentWrap__1eXmA","footer":"Section_footer__1qWbf","footerInner":"Section_footerInner__27bpH"};